<template lang="pug">
.register-card.white
  v-container(style="max-width:600px")
    div.text-center.mt-12
      h5.primary--text.my-2 Verify payment card
      h6.p2 This card registration is for the purpose of preventing
      h6.p2  fraud only. You
        b  would not be charged
        |  until you decide to
      h6.p2  subscribe to our service after the trial period.
      v-card.mt-8.mx-6.px-4.pt-4.text-center(flat outlined)
        card-list.mt-4.mb-6(@change="card = $event")
      div.text-center.mx-6
        v-btn.my-4.button-AA-medium(block flat style="text-color:white;"  color="textColorAccent" @click="saveCard()" :disabled="!done" depressed)
          .button-AA-medium.basic100--text Finish
        h6.primary400--text
          h6.c2.primary400--text  We won't charge your card.
          h6.c1.primary400--text  You may see a temporary pre-authorization charge to verify the card, which will be reversed within a week.
      v-card.elevation-0.transparent
        v-img.py-6(:src="require('@/assets/images/welcome_image.png')" contain)
        //p.mb-0.mt-3.question-text.body-2.mx-auto(@click="openZenDesk()") Have questions? Chat with us.
        v-img.mx-auto.mt-2(:src="require('@/assets/images/logo_main.png')" style="width:100px; height:32px" contain)
        v-layout.mt-n2.ml-n4
          span.caption.mx-auto © {{ getYear() }}
</template>

<script>
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList'
export default {
  name: 'RegisterCard',
  components: { CardList },
  props: ['company'],
  data () {
    return {
      card: null
    }
  },
  computed: {
    done () {
      return this.card ? true : false
    }
  },
  mounted () {
  },
  methods: {
    getYear() {
      return (new Date()).getFullYear()
    },
    saveCard() {
      this.$emit('done')
      this.trackGtag()
      this.trackPixel()
      this.$axios.post(`/companies/${this.company.id}/attribute_affiliate/`, { type: 'signup' }).catch(() => {})
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.event('sign_up')
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'StartTrial', {
        value: '1.00',
        currency: 'MYR'
      })
    }
  }
}
</script>

<style scoped>
</style>
